import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@vellum/micro-app-auth";
import { PayrollProvider } from "./lib/payroll/PayrollProvider";
import "./index.css";
import { router } from "./router";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root not found");
}

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <PayrollProvider>
        <RouterProvider router={router} />
      </PayrollProvider>
    </AuthProvider>
  </StrictMode>,
);
